import { useContext, useEffect, useMemo, useRef, useState } from "react";
import { Grid } from "semantic-ui-react";

import {
  useGetIngredientsSupplierList,
  useGetIngredientWholeList
} from "../../../../../api/ingredients";
import { TitleView } from "../../../../../components";
import CommonSplitContainer from "../../../../../components/commonSplitContainer/CommonSplitContainer";
import { DrawingContext } from "../../../../../components/drawing-tool/DrawingTool";
import IngredientDataRegister from "./IngredientDataRegister";
import SupplerRegister from "./SupplierRegister";

import MainBottomMultipleButtonView from "../../../../../components/mainBottomButtonView/MainBottomMultipleButtonView";
import { IngredientSource } from "../../../../../config/enums/IngredientType.enum";
import "./IngredientRegister.scss";
interface HandleValidation {
  resetSupplierData(): void;
  saveData(): void;
}

const IngredientRegisterModalView = () => {
  const { setNodeItem } = useContext(DrawingContext);

  const [ingredientData, setIngredientData] = useState<any>(undefined);
  const [showSupplier, setShowSupplier] = useState<boolean>(false);
  const [supplierData, setSupplierData] = useState<any>(undefined);
  const [hideIngredientView, setHideIngredientView] = useState<boolean>(false);
  const [viewEnvironmentalData, setViewEnvironmentalData] = useState<boolean>(false);

  const ingredientList: any = [];

  const ref = useRef<HandleValidation>();

  let ingredientId = useMemo(() => {
    return ingredientData?.ingredient_data?.ingredient_id || ingredientData?.ingredient_data?._id;
  }, [ingredientData]);

  useEffect(() => {
    let getSupplierIngredientDetails = Array.isArray(
      supplierData?.supplier_data?.supplierIngredientDetails
    )
      ? supplierData.supplier_data.supplierIngredientDetails.find(
          (e: any) => e.ingredient_id == ingredientId
        )
      : supplierData?.supplier_data?.supplierIngredientDetails?.data_type;

    if (getSupplierIngredientDetails?.data_type) {
      setViewEnvironmentalData(true);
    }
  }, [supplierData]);

  const { data: ingredientListByProduct, refetch: ingredientListByProductRefetch } =
    useGetIngredientWholeList(true, IngredientSource.ALL);

  const { data: ingredientSupplierList, refetch: supplerListByProductRefetch } =
    useGetIngredientsSupplierList();

  const handleSave = () => {
    if (ref?.current) {
      ref?.current?.saveData();
    }
  };

  return (
    <Grid>
      <Grid.Column computer={16} tablet={16} mobile={16}>
        <CommonSplitContainer
          topChild={
            <div>
              <TitleView
                title={!hideIngredientView ? "General Details" : "Add New Supplier"}
                CustomTitleViewMain="ingredientRegisterTitle"
              />
              <Grid className="mt-0">
                {!hideIngredientView ? (
                  <Grid.Column computer={16} tablet={16} mobile={16}>
                    <IngredientDataRegister
                      ingredientListByProduct={ingredientListByProduct}
                      ingredientRegisterData={setIngredientData}
                      refetchIngredient={ingredientListByProductRefetch}
                      currentIngredientData={ingredientData}
                      showSupplier={setShowSupplier}
                    />
                  </Grid.Column>
                ) : null}
                <Grid.Column computer={16} tablet={16} mobile={16} className="pb-1">
                  <SupplerRegister
                    ref={ref}
                    ingredientSupplierList={ingredientSupplierList}
                    ingredientData={ingredientData}
                    supplierCurrentData={() => {}}
                    ingredientList={ingredientList}
                    refetchSupplier={supplerListByProductRefetch}
                    setIngredientData={setIngredientData}
                    setSupplier={setSupplierData}
                    hideIngredientView={(status: any) => setHideIngredientView(status)}
                    disable={showSupplier}
                    setViewEnvironmentalData={setViewEnvironmentalData}
                    viewEnvironmentalData={viewEnvironmentalData}
                  />
                </Grid.Column>
              </Grid>
            </div>
          }
          bottomChild={
            <MainBottomMultipleButtonView
              leftButtons={[
                {
                  title: "Cancel",
                  onClick: () => setNodeItem(null),
                  buttonOutLine: true
                }
              ]}
              rightButtons={[
                {
                  contentView: 16,
                  title: !hideIngredientView ? "Save" : "Save Supplier",
                  onClick: () => handleSave(),
                  buttonView: showSupplier ? true : false
                }
              ]}
            />
          }
        />
      </Grid.Column>
    </Grid>
  );
};

export default IngredientRegisterModalView;
